import { render, staticRenderFns } from "./WhitelabelHeading.vue?vue&type=template&id=2c0c8b72&scoped=true&"
import script from "./WhitelabelHeading.vue?vue&type=script&lang=ts&"
export * from "./WhitelabelHeading.vue?vue&type=script&lang=ts&"
import style0 from "./WhitelabelHeading.vue?vue&type=style&index=0&id=2c0c8b72&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0c8b72",
  null
  
)

export default component.exports